import axios from 'axios';
import { getGoogleFontsListAPI } from 'polotno/config';
import { useQuery } from 'react-query';

const GOOGLE_FONTS_QUERY_KEY = 'google-fonts';

export const useGoogleFonts = () => {
    return useQuery({
        queryKey: [GOOGLE_FONTS_QUERY_KEY],
        queryFn: async () => {
            const apiUrl = getGoogleFontsListAPI();
            const response = await axios.get(apiUrl);
            return response.data;
        },
        retry: 2,
        retryDelay: 1000,
    });
};
